import { bool, node } from 'prop-types';

export default function ignoreViewOnNordicPage(View) {
  const NewComponent = props => {
    const { children, isNordicPage = false } = props;

    if (isNordicPage === true) {
      return <>{children}</>;
    }

    return <View {...props} />;
  };

  NewComponent.propTypes = {
    isNordicPage: bool,
    children: node.isRequired,
  };

  return NewComponent;
}
